type Props = {
  contextTokens: number;
  modelId: string;
  onCompact: () => void;
  compacting: boolean;
  hasConversation: boolean;
};

const COMPACT_THRESHOLD_PCT = 70;
const CRITICAL_THRESHOLD_PCT = 90;

/**
 * Per-model context-window estimates (max input tokens). Updated as we add
 * new models — see the `/api/models` payload for canonical IDs.
 */
const CONTEXT_WINDOWS: Record<string, number> = {
  "us.anthropic.claude-opus-4-7": 1_000_000,
  "us.anthropic.claude-sonnet-4-6": 200_000,
  "us.anthropic.claude-opus-4-6-v1": 200_000,
  "us.anthropic.claude-haiku-4-5-20251001-v1:0": 200_000,
};

function contextWindowFor(modelId: string): number {
  return CONTEXT_WINDOWS[modelId] ?? 200_000;
}

export function ContextIndicator({
  contextTokens,
  modelId,
  onCompact,
  compacting,
  hasConversation,
}: Props) {
  const max = contextWindowFor(modelId);
  const pct = max > 0 ? Math.min(100, (contextTokens / max) * 100) : 0;
  const tone =
    pct >= CRITICAL_THRESHOLD_PCT ? "critical" : pct >= COMPACT_THRESHOLD_PCT ? "high" : "low";
  return (
    <div className="context-indicator">
      <span title={`${contextTokens.toLocaleString()} / ${max.toLocaleString()}`}>
        {Math.round(pct)}%
      </span>
      <div className="context-bar">
        <div
          className={`context-bar-fill ${tone === "low" ? "" : tone}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <button
        type="button"
        className="context-compact"
        onClick={onCompact}
        disabled={compacting || !hasConversation || contextTokens === 0}
        title="Summarize the conversation to free context"
      >
        {compacting ? "compacting…" : "compact"}
      </button>
    </div>
  );
}
